module.exports = __webpack_public_path__ + "img/ewm.609ead37.png";